import { inject, observer } from "mobx-react";
import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Header, Modal, Table } from "semantic-ui-react";
import { IAppModel } from "../AppModel";
import {
  EmptyTableRow,
  ErrorMessage,
  SectionContainer
} from "../components/common";
import { Loading } from "../components/common/loading";
import { BAACListModel } from "../modules/BAAC/BAACListModel";
import { IBAACModel } from "../modules/BAAC/BAACModel";
import { dateTime_display_CE_TO_BE } from "../utils";

interface IBAACTransactionModal extends WithTranslation {
  trigger?: any;
  paymentReferenceNo: string;
  status: string;
  appStore?: IAppModel;
}

@inject("appStore")
@observer
class BAACTransactionModal extends React.Component<
  IBAACTransactionModal
> {
  public state = { open: false };
  public BAACList = BAACListModel.create({});
  public close = () => {
    this.setState({ open: false });
    this.BAACList.resetAll();
  };
  public open = async () => {
    await this.setState({ open: true });
    const { paymentReferenceNo, status } = this.props;
    if (paymentReferenceNo && status) {
      this.BAACList.load_data(status, paymentReferenceNo);
    }
  };
  public render() {
    const { trigger } = this.props;
    const { open } = this.state;
    return (
      <Modal
        trigger={trigger}
        onOpen={this.open}
        open={open}
        closeIcon
        onClose={this.close}
        size={"fullscreen"}
        className={"no-action"}
      >
        <Modal.Header>
          <Header textAlign="center">{"BAAC Transaction"}</Header>
        </Modal.Header>
        <Modal.Content scrolling>
          <Loading active={this.BAACList.loading} />
          <ErrorMessage
            errorobj={this.BAACList.error}
            float={true}
            timeout={10000}
          />
          <SectionContainer id="searchTable" stretch fluid basic>
            <div style={styles.containerTable}>
              <Table striped size="small" style={styles.table}>
                {this.renderTableHeader()}
                {this.renderTableBody()}
              </Table>
            </div>
          </SectionContainer>
        </Modal.Content>
      </Modal>
    );
  }

  private renderTableHeader() {
    const { t } = this.props;
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell textAlign="center" singleLine>
            {t("modal.AccountReceivableTransactionModal.createdDate")}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>
            {t("modal.AccountReceivableTransactionModal.type")}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>
            {"Operation"}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>reqDate</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>postDate</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>respCode</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>respDesc</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>reqReferenceNo</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>resReferenceNo</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>channelCode</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>bankCode</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>branchCode</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>userCode</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>terminalNo</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>terminalLocation</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>terminalType</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>verifyRefNo</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>taxId</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>compCode</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>serviceCode</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>customerName</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>accountNo</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>accountTypeCode</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>accountBranchCode</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>chequeRefNo</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>chequeUuid</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>chequeNo</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>chequeBankCode</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>chequeBranchCode</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>chequeAccountNo</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>chequeAmount</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>chequeDate</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>transAmount</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>feeAmount1</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>feeAmount2</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>feeAmount3</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>feeAmount4</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>feeAmount5</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>feeAmount6</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref1</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref2</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref3</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref4</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref5</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref6</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref7</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref8</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref9</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref10</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref11</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref12</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref13</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref14</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref15</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref16</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref17</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref18</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref19</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" singleLine>ref20</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    );
  }

  private renderTableBody() {
    const dataTable = this.BAACList.list;
    return (
      <Table.Body>
        {dataTable.length > 0 ? (
          dataTable.map((data: IBAACModel, index: number) => {
            return (
              <Table.Row key={index}>
                <Table.Cell singleLine>
                  {this.checkEmptyText(
                    dateTime_display_CE_TO_BE(data.createdDate, true)
                  )}
                </Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.type)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.method)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.reqDate)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.postDate)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.respCode)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.respDesc)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.reqReferenceNo)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.resReferenceNo)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.channelCode)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.bankCode)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.branchCode)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.userCode)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.terminalNo)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.terminalLocation)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.terminalType)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.verifyRefNo)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.taxId)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.compCode)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.serviceCode)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.customerName)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.accountNo)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.accountTypeCode)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.accountBranchCode)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.chequeRefNo)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.chequeUuid)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.chequeNo)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.chequeBankCode)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.chequeBranchCode)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.chequeAccountNo)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.chequeAmount)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.chequeDate)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.transAmount)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.feeAmount1)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.feeAmount2)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.feeAmount3)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.feeAmount4)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.feeAmount5)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.feeAmount6)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref1)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref2)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref3)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref4)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref5)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref6)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref7)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref8)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref9)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref10)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref11)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref12)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref13)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref14)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref15)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref16)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref17)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref18)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref19)}</Table.Cell>
                <Table.Cell>{this.checkEmptyText(data.ref20)}</Table.Cell>
              </Table.Row>
            );
          })
        ) : (
          <EmptyTableRow colSpan={38} />
        )}
      </Table.Body>
    );
  }

  private checkEmptyText = (value: string) => {
    return value ? value : "-";
  };
}
const styles: any = {
  containerTable: {
    overflowX: "auto"
  },
  table: {
    fontSize: ".7em"
  }
};
export default withTranslation()(BAACTransactionModal);
